import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import InfoIcon from "@mui/icons-material/Info";
import { getActionTemplate } from "../../../actions/actionTemplateActions";
import Typography from "@mui/material/Typography";
import QuestionViewerExpandableHook from "../questions/QuestionViewerExpandableHook";
import * as TEMPLATE from "../../../constants/templateConstants";
import ArgoReviewTemplateHook from "../../common/ArgoReviewTemplateHook";

function ActionReview({templateKey, templateId, width}) {
    // State hooks
    const [openQuestionReview, setOpenQuestionReview] = useState(false);
    const [selectedQuestionInfoId, setSelectedQuestionInfoId] = useState("");
    const [selectedQuestionInfoKey, setSelectedQuestionInfoKey] = useState("");
    const [selectedQuestionInfoTemplate, setSelectedQuestionInfoTemplate] = useState("");

    const dispatch = useDispatch();
    const template = useSelector(state => {
            return state.actionTemplate.hasOwnProperty(templateKey)
                ? state.actionTemplate[templateKey]
                : {}
        }
    );

    useEffect(() => {
        if (templateKey || templateId) {
            dispatch(getActionTemplate(templateKey, templateId));
        }
    }, [dispatch, templateKey, templateId]);

    const rootStyle = {
        justifyContent: "space-between",
        width: "100%",
        maxHeight: "fit-content",
        height: "fit-content",
        minHeight: "fit-content"
    };

    const templateIsLoaded = template && (!templateId || (template.id && template.id.toString() === templateId));
    if (!templateIsLoaded) {
        return null;
    }

    const setStateCallback = (stateObj) => {
        if ('openQuestionReview' in stateObj) setOpenQuestionReview(stateObj.openQuestionReview);
        if ('selectedQuestionInfoId' in stateObj) setSelectedQuestionInfoId(stateObj.selectedQuestionInfoId);
        if ('selectedQuestionInfoKey' in stateObj) setSelectedQuestionInfoKey(stateObj.selectedQuestionInfoKey);
        if ('selectedQuestionInfoTemplate' in stateObj) setSelectedQuestionInfoTemplate(stateObj.selectedQuestionInfoTemplate);
    };

    const handleToolbarButtonClick = (event, fieldName, buttonTitle) => {
        switch (buttonTitle) {
            case "BACK":
                // Used on info icon button from question accordions
                setOpenQuestionReview(false);
                break;
            // no default
        }
        event.preventDefault(); // Fix for the enter key propagating to the next focusable element
    };

    if (openQuestionReview) {
        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.QUESTION}
            templateId={selectedQuestionInfoId}
            templateKey={selectedQuestionInfoKey}
            selectedTemplate={selectedQuestionInfoTemplate}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={width}
        />;
    }

    return (
        template.hasOwnProperty("questionKeys") ?
            <div style={rootStyle}>
                <div style={{ width: "95%", padding: "32px" }}>

                    <Typography variant="h6" component="div">
                        Action Information:
                    </Typography>

                    <div>&nbsp;</div>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <div style={{ color: "lightgray" }}>Name:</div>
                        <div>&nbsp;&nbsp;</div>
                        <div style={{ fontSize: "16px" }}>{template.name}</div>
                    </div>

                    <div style={{ height: "20px" }}>&nbsp;</div>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <div style={{ color: "lightgray" }}>Description:</div>
                        {template.description ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <InfoIcon style={{ minWidth: "48px" }} />
                            <div style={{fontSize: "16px" }}>{template.description}</div>
                        </div> : ""}
                    </div>

                    <div style={{ height: "20px" }}>&nbsp;</div>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <div style={{ color: "lightgray" }}>Type:</div>
                        <div>&nbsp;&nbsp;</div>
                        <div style={{ fontSize: "16px" }}>{template.type}</div>
                    </div>

                    {/*// ===========================================================================================================*/}
                    {/*// ASSIGNED QUESTIONS LIST */}
                    {/*// ===========================================================================================================*/}

                    <QuestionViewerExpandableHook
                        parentName={"ActionReview"}
                        parentType={TEMPLATE.TYPE.ACTION}
                        parentTemplate={template}
                        questionKeys={template.questionKeys}
                        showIconButtonReorder={false}
                        showIconButtonEdit={false}
                        showIconButtonRemove={false}
                        setStateCallback={setStateCallback}
                    />
                </div>
            </div>
            : ""
    );
}

ActionReview.propTypes = {
    template: PropTypes.object,
    templateKey: PropTypes.string,
    templateId: PropTypes.string,
    style: PropTypes.object
};

export default ActionReview;